import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Gallery.css';
// import img1 from '../assets/Gallery/IMG_5592.JPG';
// import img2 from '../assets/Gallery/IMG_5595.JPG';
// import img3 from '../assets/Gallery/IMG_5597.JPG';
// import img4 from '../assets/Gallery/IMG_5599.JPG';
// import img5 from '../assets/Gallery/IMG_5600.JPG';
// import img6 from '../assets/Gallery/IMG_5601.JPG';
// import img7 from '../assets/Gallery/IMG_5602.JPG';
// import img8 from '../assets/Gallery/IMG_5604.JPG';
// import img9 from '../assets/Gallery/IMG_5605.JPG';
// import img10 from '../assets/Gallery/IMG_5607.JPG';
// import img11 from '../assets/Gallery/IMG_5608.JPG';
// import img12 from '../assets/Gallery/IMG_6236.HEIC';
//import img13 from '../assets/Gallery/IMG_6241.HEIC';
//import img14 from '../assets/Gallery/IMG_6244.HEIC';
//import img15 from '../assets/Gallery/Untitled design (1).png';
//import img16 from '../assets/Gallery/Untitled design (2).png';
//import img17 from '../assets/Gallery/Untitled design (3).png';
//import img18 from '../assets/Gallery/Untitled design (4).png';
//import img19 from '../assets/Gallery/Untitled design (5).png';
//import img20 from '../assets/Gallery/Untitled design (6).png';
//import img21 from '../assets/Gallery/Untitled design (7).png';
//import img22 from '../assets/Gallery/Untitled design (8).png';
//import img23 from '../assets/Gallery/Untitled design (9).png';
//import img24 from '../assets/Gallery/Untitled design (10).png';
//import img25 from '../assets/Gallery/Untitled design.png';

const Gallery = () => {
  const allImages = [
    //   { id: 1, image: img1 },
    // { id: 2, image: img2 },
    //  { id: 3, image: img3 },
    //  { id: 4, image: img4 },
    //  { id: 5, image: img5 },
    //  { id: 6, image: img6 },
    //  { id: 7, image: img7 },
    //  { id: 8, image: img8 },
    //  { id: 9, image: img9 },
    //  { id: 10, image: img10 },
    //  { id: 11, image: img11 },
    //  { id: 12, image: img12 },
    //  { id: 13, image: img13 },
    //  { id: 14, image: img14 },
    // { id: 15, image: img15 },
    //  { id: 16, image: img16 },
    //  { id: 17, image: img17 },
    //  { id: 18, image: img18 },
    //  { id: 19, image: img19 },
    //  { id: 20, image: img20 },
    //  { id: 21, image: img21 },
    //  { id: 22, image: img22 },
    //   { id: 23, image: img23 },
    //   { id: 24, image: img24 },
    //   { id: 25, image: img25 },
  ];

  return (
    <section className="gallery-section">
      <div className="gallery-container">
        <motion.div
          className="gallery-header"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="gallery-title">Our Work Gallery</h2>
          <p className="gallery-subtitle">
            Explore our portfolio of stunning beauty transformations
          </p>
        </motion.div>

        <motion.div layout className="gallery-grid">
          <AnimatePresence>
            {allImages.map((image) => (
              <motion.div
                layout
                key={image.id}
                className="gallery-item"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.8 }}
                transition={{ duration: 0.5, ease: 'easeInOut' }}
                whileHover="hover"
              >
                <img
                  src={image.image}
                  alt={image.title}
                  className="gallery-img"
                />
                <motion.div
                  className="gallery-overlay"
                  variants={{
                    hover: { opacity: 1 },
                    initial: { opacity: 0 }
                  }}
                  transition={{ duration: 0.4, ease: 'easeOut' }}
                >
                </motion.div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>

        <motion.div
          className="gallery-cta"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <h3>Ready to Transform Your Look?</h3>
          <p>Book your appointment and join our satisfied clients</p>
          <motion.button
            className="cta-button"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Book Now
          </motion.button>
        </motion.div>
      </div>
    </section>
  );
};

export default Gallery;
